
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.prefooter-wrapper{
  display:grid;
  grid-template-columns:1fr;
  grid-template-rows:3.75rem 13.75rem 1fr;
  padding-top:var(--container-py-normal);
}

  @media (min-width: 768px){.prefooter-wrapper{
    grid-template-rows:9.25rem 8.25rem 1fr
}
  }

  @media (min-width: 1024px){.prefooter-wrapper{
    grid-template-columns:9.25rem 18.75rem 1fr;
    grid-template-rows:1fr
}
  }

  @media (min-width: 1380px){.prefooter-wrapper{
    grid-template-columns:repeat(2, 1fr);
    grid-template-rows:7rem 1fr;
    padding-top:0
}
  }

.blue-row2{
  border-radius:var(--border-radius-rounded-default);
  background-color:var(--color-primary-lightest);
  grid-area:2 / 1 / 4 / 1;
  padding:3.75rem;
  z-index:1;
}

@media (min-width: 1024px){

.blue-row2{
    grid-area:1 / 2 / 1 / 4
}
  }

@media (min-width: 1380px){

.blue-row2{
    grid-area:2 / 1 / 3 / 3
}
  }

.white-row1{
  grid-area:1 / 1 / 2 / 1;
  background-color:var(--color-neutral-white);
  z-index:1;
  display:block;
}

@media (min-width: 1380px){

.white-row1{
    grid-area:1 / 1 / 2 / 3
}
  }

.white-column1{
  display:none;
}

@media (min-width: 1024px){

.white-column1{
    grid-area:1 / 1 / 1 / 2;
    padding-right:5rem;
    background-color:var(--color-neutral-white);
    z-index:1;
    display:block
}
  }

@media (min-width: 1380px){

.white-column1{
    display:none
}
  }

.prefooter-icon{
  justify-content:center;
  display:flex;
  z-index:3;
  grid-area:1 / 1 / 2 / 1;
}

@media (min-width: 1024px){

.prefooter-icon{
    grid-area:1 / 1 / 1 / 3
}
  }

@media (min-width: 1380px){

.prefooter-icon{
    justify-content:flex-end;
    padding:0 11rem 1.7rem 0;
    grid-area:1 / 1 / 3 / 2
}
  }

@media (min-width: 1920px){

.prefooter-icon{
    display:flex;
    justify-content:flex-end
}
  }

[cloned-slot-name='prefooter-icon']{
  display:contents;
}

sic-icon.icon-style{
  min-height:17.5rem;
}

@media (min-width: 1024px){

sic-icon.icon-style{
    min-height:28rem
}
  }

@media (min-width: 1380px){

sic-icon.icon-style{
    min-height:34.5rem;
    max-width:667px
}
  }

.text-wrapper{
  padding:1.5rem;
  grid-area:3 / 1 / 4 / 3;
  display:flex;
  gap:1.5rem;
  flex-direction:column;
  justify-content:top;
  z-index:1;
}

@media (min-width: 768px){

.text-wrapper{
    padding:5rem
}
  }

@media (min-width: 1024px){

.text-wrapper{
    gap:2rem;
    padding:3.75rem 8.06rem 3.75rem 0;
    grid-area:1 / 3 / 1 / 5
}
  }

@media (min-width: 1380px){

.text-wrapper{
    max-width:667px;
    gap:2rem;
    grid-area:2 / 2 / 3 / 3;
    display:flex;
    align-items:flex-start;
    justify-content:center
}
  }

.text{
  --sic-body-text--font-size:var(--body-04-font-size);
  overflow:hidden;
  font-size:var(--sic-body-text--font-size);
  height:clamp(var(--body-font-size));
  display:flex;
  flex-direction:column;
  justify-content:top;
  align-items:flex-start;
  width:100%;
  color:var(--sic-text-color);
}

.text p{
    margin-block-start:0;
  }

h1{
  margin-block-end:0em;
}

sic-heading{
  font-size:var(--headline-07-font-size);
  line-height:var(--headline-07-font-size);
  font-weight:var(--fw-bold);
  color:var(--sic-heading-color);
}
`;